import styled from 'styled-components';

export const MessagesContainer = styled.div`
  width: 70%;
  margin-top: 16px;
  margin: auto;
  padding-top: 20px;
`;
export const ImageContainer = styled.div`
  margin: 70px auto;
  width: 33%;
`;
export const MessagesStepContainer = styled.div`
  width: 100%;
  padding: 20px 20px 0 20px;
`;
export const MessagesListContainer = styled.div`
  height: 340px;
  overflow-y: scroll;
  width: 100%;
`;
